// 30-day meal plans for weight loss & weight gain
// Weight gain: Indian vegetarian, 7 meal slots, ~300–500 kcal surplus
// Weight loss: 4 meal slots, calorie-controlled

// ---------------- WEIGHT LOSS (existing 4-meal structure) ----------------
const lossBreakfasts = [
  { name: 'Greek yogurt with berries & almonds', kcal: 320 },
  { name: 'Veggie omelette with whole-grain toast', kcal: 350 },
  { name: 'Oatmeal with banana & chia seeds', kcal: 340 },
  { name: 'Avocado toast on rye with poached egg', kcal: 360 },
  { name: 'Cottage cheese with sliced peach', kcal: 300 },
  { name: 'Green smoothie: spinach, apple, protein', kcal: 320 },
  { name: 'Scrambled paneer bhurji with roti', kcal: 330 },
];
const lossLunches = [
  { name: 'Grilled chicken salad with lemon dressing', kcal: 420 },
  { name: 'Quinoa bowl with roasted veggies & feta', kcal: 450 },
  { name: 'Turkey lettuce wraps with hummus', kcal: 400 },
  { name: 'Lentil soup with side salad', kcal: 410 },
  { name: 'Dal with 2 rotis and cucumber salad', kcal: 430 },
  { name: 'Chickpea curry with cauliflower rice', kcal: 440 },
  { name: 'Grilled fish with steamed broccoli', kcal: 460 },
];
const lossDinners = [
  { name: 'Baked cod with asparagus & sweet potato', kcal: 480 },
  { name: 'Stir-fried tofu with mixed vegetables', kcal: 450 },
  { name: 'Zucchini noodles with turkey meatballs', kcal: 470 },
  { name: 'Grilled shrimp skewers with quinoa', kcal: 460 },
  { name: 'Mixed veg sabzi with 2 rotis', kcal: 440 },
  { name: 'Miso-glazed salmon with bok choy', kcal: 480 },
  { name: 'Chicken breast with roasted brussels sprouts', kcal: 470 },
];
const lossSnacks = [
  { name: 'Apple slices with almond butter', kcal: 180 },
  { name: 'Handful of walnuts', kcal: 170 },
  { name: 'Carrot sticks with hummus', kcal: 160 },
  { name: 'Boiled egg & cucumber', kcal: 150 },
  { name: 'Protein shake with water', kcal: 140 },
  { name: 'Greek yogurt cup', kcal: 160 },
  { name: 'Roasted chana', kcal: 170 },
];

// ---------------- WEIGHT LOSS — VEGETARIAN (Indian, 7 meal slots) ----------------
// Meals per day: earlyMorning, breakfast, midMorning, lunch, eveningSnack, dinner, optionalBedtime

const vlEarlyMorningOptions = [
  { name: '1 glass warm water with lemon + 5 soaked almonds + 2 walnuts', kcal: 90 },
  { name: '1 glass warm water with lemon & honey + 6 soaked almonds', kcal: 100 },
  { name: '1 glass warm turmeric water + 5 soaked almonds + 1 walnut', kcal: 80 },
  { name: '1 glass warm water with lemon + 1 tsp chia seeds + 4 almonds', kcal: 90 },
  { name: '1 glass jeera water + 5 soaked almonds + 2 walnuts', kcal: 90 },
];

const vlBreakfastOptions = [
  { name: '2 moong dal chillas with mint chutney', kcal: 320, tag: 'Mon' },
  { name: 'Vegetable oats (1 bowl) cooked in low-fat milk', kcal: 300, tag: 'Mon' },
  { name: 'Sprouts salad with tomato, cucumber & lemon (1 bowl)', kcal: 280, tag: 'Tue' },
  { name: 'Vegetable upma (1 bowl) with grated coconut', kcal: 310, tag: 'Wed' },
  { name: 'Moong dal chilla (2) with mint chutney & curd (small bowl)', kcal: 340, tag: 'Thu' },
  { name: 'Vegetable daliya (1 bowl) with peas & carrots', kcal: 300, tag: 'Fri' },
  { name: 'Besan chilla (2) stuffed with vegetables', kcal: 320, tag: 'Sat' },
  { name: 'Vegetable idli (3) with sambar & mint chutney', kcal: 310, tag: 'Sun' },
  { name: 'Vegetable poha (1 bowl) with peanuts & lemon', kcal: 300 },
];

const vlMidMorningOptions = [
  { name: '1 apple', kcal: 90 },
  { name: '1 orange', kcal: 70 },
  { name: '1 guava', kcal: 70 },
  { name: '1 pear', kcal: 100 },
  { name: '1 bowl papaya', kcal: 80 },
  { name: '1 small bowl watermelon cubes', kcal: 80 },
];

const vlLunchOptions = [
  { name: '2 whole-wheat rotis + 1 bowl dal + 1 bowl mixed vegetables + cucumber-tomato salad', kcal: 460 },
  { name: '2 whole-wheat rotis + 1 bowl rajma + 1 bowl bhindi sabzi + salad', kcal: 480 },
  { name: '2 whole-wheat rotis + 1 bowl chana dal + palak sabzi + salad', kcal: 470 },
  { name: '1 small bowl brown rice + 1 bowl dal + lauki sabzi + cucumber salad', kcal: 450 },
  { name: '2 whole-wheat rotis + 1 bowl toor dal + karela sabzi + salad', kcal: 440 },
  { name: '2 whole-wheat rotis + 1 bowl chole + tinda sabzi + salad', kcal: 470 },
  { name: '2 whole-wheat rotis + 1 bowl moong dal + baingan bharta + salad', kcal: 450 },
];

const vlEveningSnackOptions = [
  { name: 'Green tea (no sugar) + roasted chana (30 g)', kcal: 130 },
  { name: 'Black coffee (no sugar) + roasted chana (30 g)', kcal: 130 },
  { name: 'Green tea + 4 whole-wheat crackers', kcal: 140 },
  { name: 'Black coffee (no sugar) + roasted makhana (25 g)', kcal: 120 },
  { name: 'Green tea + a handful of sprouts chaat', kcal: 130 },
];

const vlDinnerOptions = [
  { name: '1 bowl vegetable soup + paneer bhurji (100 g) + sautéed vegetables', kcal: 430 },
  { name: '1 bowl tomato soup + tofu bhurji (100 g) + sautéed vegetables', kcal: 410 },
  { name: '1 bowl clear vegetable soup + 100 g grilled paneer tikka + salad', kcal: 420 },
  { name: '1 bowl spinach soup + 100 g paneer bhurji + steamed vegetables', kcal: 420 },
  { name: '1 bowl mushroom soup + tofu stir-fry (100 g) + sautéed veggies', kcal: 400 },
  { name: '1 bowl mixed veg soup + 100 g grilled paneer + salad', kcal: 420 },
  { name: '1 bowl lentil soup + tofu curry (100 g) + steamed vegetables', kcal: 430 },
];

const vlOptionalBedtimeOptions = [
  { name: '1 cup warm skim milk (no sugar)', kcal: 90 },
  { name: '1 cup warm skim milk with a pinch of turmeric', kcal: 90 },
  { name: '1 cup warm skim milk with 2 soaked almonds', kcal: 100 },
  { name: '1 cup low-fat milk with a pinch of cinnamon', kcal: 90 },
];

// ---------------- WEIGHT LOSS — NON-VEG (Indian, gym-focused) ----------------
// 8 slots incl. pre-workout, workout marker, and post-workout dinner

const nvlEarlyMorningOptions = [
  { name: '1 glass warm water with lemon + black coffee or green tea (optional)', kcal: 20 },
  { name: 'Warm lemon water + green tea (no sugar)', kcal: 15 },
  { name: 'Warm water with lemon + black coffee', kcal: 15 },
  { name: 'Warm jeera water + green tea', kcal: 10 },
];

// Week 1 breakfasts (days 1-7)
const nvlBreakfastsWk1 = [
  { name: '4 boiled eggs (2 whole + 2 whites) + 50 g oats with skim milk + 1 apple', kcal: 480 },
  { name: '4 boiled eggs (2 whole + 2 whites) + 40 g oats + 1 apple', kcal: 460 },
];
// Week 2 (days 8-14)
const nvlBreakfastsWk2 = [
  { name: '3-egg vegetable omelet + 1 slice whole-wheat toast + 1 orange', kcal: 420 },
  { name: '2-egg omelet + 40 g oats with skim milk + 1 fruit', kcal: 430 },
];
// Week 3 (days 15-21)
const nvlBreakfastsWk3 = [
  { name: '3 boiled eggs + cucumber slices + 30 g oats', kcal: 380 },
  { name: '4 egg whites + 2 whole eggs + cucumber + 30 g oats', kcal: 400 },
];
// Week 4 (days 22-30)
const nvlBreakfastsWk4 = [
  { name: '3-egg vegetable omelet (spinach, onion, tomato) + 1 slice toast', kcal: 400 },
  { name: '3-egg mushroom & pepper omelet + 30 g oats', kcal: 410 },
];

const nvlMidMorningOptions = [
  { name: '200 g low-fat curd + 10 almonds', kcal: 260 },
  { name: '200 g Greek yogurt + 10 almonds', kcal: 280 },
  { name: '200 g low-fat curd + 8 walnuts', kcal: 290 },
  { name: '150 g Greek yogurt + 5 almonds + 3 walnuts', kcal: 250 },
];

// Lunch pools per week
const nvlLunchesWk1 = [
  { name: '200 g grilled chicken breast + 1–2 whole-wheat rotis + mixed vegetables + salad (cucumber, tomato, carrot)', kcal: 560 },
  { name: '200 g grilled chicken + 2 rotis + sautéed vegetables + salad', kcal: 570 },
];
const nvlLunchesWk2 = [
  { name: '200 g chicken breast + ½ cup brown rice + mixed vegetables + salad', kcal: 550 },
  { name: '200 g tandoori chicken + ½ cup brown rice + sautéed veg + salad', kcal: 560 },
];
const nvlLunchesWk3 = [
  { name: '200 g grilled chicken + sautéed vegetables + green salad', kcal: 520 },
  { name: '200 g chicken tikka + sautéed vegetables with olive oil + salad', kcal: 540 },
];
const nvlLunchesWk4 = [
  { name: '200 g grilled chicken + 1 roti + sautéed vegetables + salad', kcal: 550 },
  { name: '200 g chicken curry (light) + 1 roti + vegetables + salad', kcal: 560 },
];

const nvlPreWorkoutOptions = [
  { name: '1 banana + black coffee (optional)', kcal: 130 },
  { name: '1 banana + green tea (optional)', kcal: 120 },
  { name: '1 apple + black coffee', kcal: 100 },
];

const nvlWorkoutSlot = { name: 'Gym / home workout session (see weekly split in tips)', kcal: 0 };

const nvlPostWorkoutDinnerOptions = [
  { name: '200 g grilled chicken + 1 bowl sautéed vegetables + 1 cup dal (optional)', kcal: 480 },
  { name: '200 g grilled fish + 1 bowl sautéed vegetables + 1 cup dal (optional)', kcal: 470 },
  { name: '200 g grilled chicken + steamed vegetables + 1 cup dal', kcal: 490 },
  { name: '200 g baked fish + sautéed spinach & beans + 1 cup dal', kcal: 480 },
  { name: '200 g grilled chicken + mixed vegetables + clear soup', kcal: 460 },
  { name: '200 g grilled fish + clear vegetable soup + salad', kcal: 440 },
];

const nvlBeforeBedOptions = [
  { name: '150 g low-fat curd', kcal: 110 },
  { name: '100 g paneer (low-fat)', kcal: 180 },
  { name: '150 g Greek yogurt', kcal: 130 },
  { name: '100 g cottage cheese', kcal: 160 },
];

// ---------------- WEIGHT GAIN (Indian vegetarian, 7-meal Indian style) ----------------
// Meals per day: earlyMorning, breakfast, midMorning, lunch, eveningSnack, dinner, beforeBed

const earlyMorningOptions = [
  { name: '1 glass warm milk + 5 dates + 10 almonds + 5 walnuts + 2 bananas', kcal: 520 },
  { name: '1 glass warm milk + 4 dates + soaked almonds (10) + 1 banana + 1 apple', kcal: 480 },
  { name: '1 glass warm milk with turmeric + 5 dates + handful of mixed nuts + 2 bananas', kcal: 540 },
  { name: '1 glass warm milk + 2 figs + 6 dates + 10 cashews + 1 banana', kcal: 500 },
  { name: '1 glass warm milk + soaked raisins & almonds + 2 bananas', kcal: 490 },
];

const breakfastOptions = [
  { name: '4 vegetable parathas with curd + 1 glass fresh fruit juice', kcal: 780 },
  { name: 'Oats cooked in milk with nuts, raisins & peanut butter + banana smoothie', kcal: 760 },
  { name: '3 stuffed aloo parathas with curd + mango milkshake', kcal: 820 },
  { name: 'Poha with peanuts & vegetables + boiled eggs / paneer + banana shake', kcal: 750 },
  { name: 'Besan chilla (3) with curd & chutney + 1 glass fruit juice', kcal: 720 },
  { name: 'Upma with vegetables & cashews + peanut butter toast + milk', kcal: 780 },
  { name: 'Idli (4) with sambar & coconut chutney + banana smoothie', kcal: 740 },
];

const midMorningOptions = [
  { name: '1 mango + 100 g paneer chaat', kcal: 380 },
  { name: '1 banana + 100 g sprouts chaat', kcal: 340 },
  { name: '1 bowl chikoo + roasted chana with jaggery', kcal: 360 },
  { name: '1 cup grapes + 100 g paneer tikka', kcal: 370 },
  { name: '1 apple + 1 boiled egg or 100 g paneer', kcal: 350 },
  { name: '1 pear + handful of trail mix (nuts + seeds + raisins)', kcal: 380 },
];

const lunchOptions = [
  { name: '4 chapatis + 1½ cups rice + dal + rajma + paneer curry + salad + curd', kcal: 1050 },
  { name: '4 chapatis + rice + dal + chole + soybean curry + salad + curd', kcal: 1020 },
  { name: '4 chapatis + jeera rice + dal makhani + palak paneer + salad + curd', kcal: 1080 },
  { name: '3 chapatis + rice + dal + kadhi + paneer bhurji + mixed veg + curd', kcal: 1000 },
  { name: '4 chapatis + curd rice + dal + rajma masala + malai kofta + salad', kcal: 1070 },
  { name: '4 chapatis + veg pulao + dal + chana masala + shahi paneer + curd', kcal: 1090 },
  { name: '4 chapatis + rice + sambar + rasam + paneer butter masala + salad + curd', kcal: 1060 },
];

const eveningSnackOptions = [
  { name: 'Peanut butter sandwich (4 slices) + banana-oats-peanut butter milkshake', kcal: 720 },
  { name: 'Paneer sandwich (4 slices) + mango-milk shake with oats', kcal: 700 },
  { name: 'Sprouts & paneer bhel + banana smoothie with peanut butter', kcal: 680 },
  { name: 'Grilled cheese sandwich + chikoo-milk shake with nuts', kcal: 730 },
  { name: 'Aloo tikki (2) with chutney + chocolate protein shake with milk', kcal: 710 },
  { name: 'Dhokla (6 pieces) with green chutney + banana peanut-butter shake', kcal: 690 },
  { name: 'Vegetable cutlets (3) + strawberry-milk-oats shake', kcal: 700 },
];

const dinnerOptions = [
  { name: '4 chapatis + rice + dal + soybean curry + mixed vegetables + curd', kcal: 950 },
  { name: '4 chapatis + rice + dal + paneer curry + bhindi masala + curd', kcal: 970 },
  { name: '4 chapatis + rice + dal + kofta curry + aloo gobi + curd', kcal: 990 },
  { name: '4 chapatis + rice + dal + palak paneer + baingan bharta + curd', kcal: 960 },
  { name: '4 chapatis + rice + dal + matar paneer + carrot-beans sabzi + curd', kcal: 970 },
  { name: '4 chapatis + rice + dal + kadhai paneer + mixed veg curry + curd', kcal: 980 },
  { name: '4 chapatis + rice + dal + soya chunks curry + lauki sabzi + curd', kcal: 940 },
];

const beforeBedOptions = [
  { name: '1 glass full-fat milk + 1 tbsp peanut butter', kcal: 260 },
  { name: '1 glass full-fat milk + handful of mixed nuts (almonds, walnuts, cashews)', kcal: 280 },
  { name: '1 glass full-fat milk with turmeric + 4 soaked almonds & 2 walnuts', kcal: 240 },
  { name: '1 glass warm milk + 1 tbsp almond butter', kcal: 260 },
  { name: '1 glass milk with a pinch of cinnamon + 2 tbsp mixed seeds', kcal: 250 },
];

// ---------------- WEIGHT GAIN — NON-VEG (Indian/mixed, 8 meal slots) ----------------
// Meals per day: earlyMorning, breakfast, midMorning, lunch, preWorkout, postWorkout, dinner, beforeBed

const nvEarlyMorningOptions = [
  { name: '1 glass full-fat milk + 2 bananas + 6 almonds + 6 walnuts + 5 dates', kcal: 560 },
  { name: '1 glass full-fat milk + 2 bananas + handful of soaked almonds + 4 dates', kcal: 520 },
  { name: '1 glass full-fat milk with honey + 1 banana + 1 apple + mixed nuts', kcal: 540 },
  { name: '1 glass full-fat milk + 2 bananas + 6 cashews + 4 walnuts + 5 dates', kcal: 570 },
];

const nvBreakfastOptions = [
  { name: '4-egg omelet + 4 slices whole-wheat toast with peanut butter + 1 glass milk', kcal: 820 },
  { name: '4 boiled eggs + 4 slices multigrain toast with peanut butter + 1 glass milk', kcal: 780 },
  { name: '3-egg cheese scramble + 3 slices whole-wheat toast with butter + 1 glass milk', kcal: 800 },
  { name: 'Egg bhurji (4 eggs) with onions & tomato + 3 chapatis + 1 glass milk', kcal: 810 },
  { name: '4 poached eggs + avocado toast (2 slices) + 1 glass milk', kcal: 790 },
  { name: 'Chicken keema paratha (2) with curd + 1 glass milk', kcal: 830 },
];

const nvMidMorningOptions = [
  { name: '200 g yogurt + 1 banana + handful of mixed nuts', kcal: 420 },
  { name: '200 g Greek yogurt + 1 mango + handful of almonds & walnuts', kcal: 440 },
  { name: '200 g yogurt + 1 chikoo + 10 cashews & 5 walnuts', kcal: 410 },
  { name: '200 g yogurt with honey + 1 apple + mixed nuts', kcal: 420 },
  { name: 'Cottage cheese (150 g) + 1 banana + handful of pistachios', kcal: 430 },
];

const nvLunchOptions = [
  { name: '250 g grilled chicken breast + 2 cups rice + 2 chapatis + 1 bowl dal + salad with olive oil', kcal: 1120 },
  { name: '250 g fish curry + 2 cups rice + 2 chapatis + dal + salad with olive oil', kcal: 1080 },
  { name: '250 g chicken curry + 2 cups jeera rice + 2 chapatis + dal fry + salad', kcal: 1130 },
  { name: 'Chicken biryani (2 cups) + raita + 250 g chicken kebabs + salad', kcal: 1150 },
  { name: 'Grilled fish (250 g) + 2 cups pulao + 2 chapatis + dal + salad', kcal: 1090 },
  { name: '250 g chicken tikka + 2 cups rice + 2 chapatis + dal makhani + salad', kcal: 1140 },
  { name: 'Mutton curry (200 g) + 2 cups rice + 2 chapatis + dal + salad', kcal: 1160 },
];

const preWorkoutOptions = [
  { name: '1 banana + black coffee + peanut butter sandwich (2 slices)', kcal: 420 },
  { name: '1 banana + peanut butter sandwich (2 slices) + black coffee', kcal: 420 },
  { name: '2 bananas + 1 tbsp honey + black coffee', kcal: 340 },
  { name: '1 banana + oats with milk (small bowl) + black coffee', kcal: 400 },
  { name: 'Peanut butter & jelly sandwich (2 slices) + black coffee', kcal: 410 },
];

const postWorkoutOptions = [
  { name: '5 egg whites + 2 whole eggs + 1 banana + 1 glass milk', kcal: 560 },
  { name: '200 g grilled chicken + 1 banana + 1 glass milk', kcal: 580 },
  { name: 'Whey protein shake with milk & banana + 4 boiled egg whites + 2 yolks', kcal: 570 },
  { name: '200 g chicken breast + 1 banana + chocolate milk (1 glass)', kcal: 600 },
  { name: 'Tuna salad (150 g) with olive oil + 1 banana + 1 glass milk', kcal: 550 },
];

const nvDinnerOptions = [
  { name: '250 g grilled chicken + 2 chapatis + 1 cup rice + mixed vegetables', kcal: 1000 },
  { name: '250 g fish tikka + 2 chapatis + 1 cup rice + sautéed vegetables', kcal: 990 },
  { name: '250 g chicken curry + 2 chapatis + 1 cup rice + mixed veg sabzi', kcal: 1030 },
  { name: '250 g grilled fish + 2 chapatis + 1 cup rice + palak-based curry', kcal: 1010 },
  { name: '250 g tandoori chicken + 2 chapatis + 1 cup rice + mixed vegetables', kcal: 1020 },
  { name: '200 g mutton curry + 2 chapatis + 1 cup rice + mixed vegetables', kcal: 1050 },
];

const nvBeforeBedOptions = [
  { name: '1 glass full-fat milk + 2 boiled eggs', kcal: 320 },
  { name: '1 glass full-fat milk + 100 g paneer', kcal: 340 },
  { name: '1 glass full-fat milk + 2 boiled eggs with black pepper', kcal: 320 },
  { name: '1 glass warm milk + 100 g cottage cheese', kcal: 330 },
  { name: '1 glass full-fat milk with turmeric + 2 boiled eggs', kcal: 320 },
];

const pick = (arr, i) => arr[i % arr.length];

// Build 30-day loss plan — mixed/non-veg (4 slots)
export const weightLossPlan = Array.from({ length: 30 }, (_, i) => {
  const b = pick(lossBreakfasts, i);
  const l = pick(lossLunches, i + 2);
  const d = pick(lossDinners, i + 4);
  const s = pick(lossSnacks, i + 1);
  return {
    day: i + 1,
    meals: [
      { key: 'breakfast', label: 'Breakfast', time: '8:00–9:00 AM', ...b },
      { key: 'snack', label: 'Snack', time: '11:00 AM', ...s },
      { key: 'lunch', label: 'Lunch', time: '1:00–2:00 PM', ...l },
      { key: 'dinner', label: 'Dinner', time: '7:00–8:00 PM', ...d },
    ],
    total: b.kcal + l.kcal + d.kcal + s.kcal,
  };
});

// Build 30-day loss plan — vegetarian (Indian, 7 slots)
// Days rotate weekly-tagged breakfasts (Mon..Sun) then fall back to unrestricted ones
const weekdayTags = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
const vlPickBreakfast = (dayIndex) => {
  const tag = weekdayTags[dayIndex % 7];
  const matches = vlBreakfastOptions.filter((o) => o.tag === tag);
  if (matches.length > 0) return matches[Math.floor(dayIndex / 7) % matches.length];
  return vlBreakfastOptions[dayIndex % vlBreakfastOptions.length];
};

export const weightLossPlanVeg = Array.from({ length: 30 }, (_, i) => {
  const em = pick(vlEarlyMorningOptions, i);
  const bf = vlPickBreakfast(i);
  const mm = pick(vlMidMorningOptions, i);
  const ln = pick(vlLunchOptions, i);
  const es = pick(vlEveningSnackOptions, i);
  const dn = pick(vlDinnerOptions, i + 2);
  const ob = pick(vlOptionalBedtimeOptions, i);
  return {
    day: i + 1,
    meals: [
      { key: 'earlyMorning', label: 'Early morning', time: '6:30–7:00 AM', ...em },
      { key: 'breakfast', label: 'Breakfast', time: '8:00 AM', ...bf },
      { key: 'midMorning', label: 'Mid-morning snack', time: '11:00 AM', ...mm },
      { key: 'lunch', label: 'Lunch', time: '1:30 PM', ...ln },
      { key: 'eveningSnack', label: 'Evening snack', time: '4:30 PM', ...es },
      { key: 'dinner', label: 'Dinner', time: '7:30 PM', ...dn },
      { key: 'beforeBed', label: 'Optional bedtime', time: '9:00 PM', ...ob },
    ],
    total: em.kcal + bf.kcal + mm.kcal + ln.kcal + es.kcal + dn.kcal + ob.kcal,
  };
});

// Build 30-day loss plan — non-veg (Indian, gym-focused, 8 slots) with 4-week rotation
const nvlWeekPools = {
  1: { bfs: nvlBreakfastsWk1, lns: nvlLunchesWk1 },
  2: { bfs: nvlBreakfastsWk2, lns: nvlLunchesWk2 },
  3: { bfs: nvlBreakfastsWk3, lns: nvlLunchesWk3 },
  4: { bfs: nvlBreakfastsWk4, lns: nvlLunchesWk4 },
};

export const weightLossPlanNonVeg = Array.from({ length: 30 }, (_, i) => {
  const weekNum = Math.min(4, Math.floor(i / 7) + 1);
  const pool = nvlWeekPools[weekNum];
  const em = pick(nvlEarlyMorningOptions, i);
  const bf = pick(pool.bfs, i);
  const mm = pick(nvlMidMorningOptions, i);
  const ln = pick(pool.lns, i);
  const pre = pick(nvlPreWorkoutOptions, i);
  const post = pick(nvlPostWorkoutDinnerOptions, i);
  const bb = pick(nvlBeforeBedOptions, i);
  return {
    day: i + 1,
    meals: [
      { key: 'earlyMorning', label: 'Early morning', time: '6:30–7:00 AM', ...em },
      { key: 'breakfast', label: 'Breakfast', time: '8:00 AM', ...bf },
      { key: 'midMorning', label: 'Mid-morning snack', time: '11:00 AM', ...mm },
      { key: 'lunch', label: 'Lunch', time: '1:30 PM', ...ln },
      { key: 'preWorkout', label: 'Pre-workout', time: '4:30 PM', ...pre },
      { key: 'postWorkout', label: 'Workout', time: '6:00–7:00 PM', ...nvlWorkoutSlot },
      { key: 'dinner', label: 'Post-workout dinner', time: '7:30 PM', ...post },
      { key: 'beforeBed', label: 'Before bed', time: '10:00 PM', ...bb },
    ],
    total: em.kcal + bf.kcal + mm.kcal + ln.kcal + pre.kcal + post.kcal + bb.kcal,
  };
});

// Build 30-day gain plan — vegetarian (7 slots)
export const weightGainPlan = Array.from({ length: 30 }, (_, i) => {
  const em = pick(earlyMorningOptions, i);
  const bf = pick(breakfastOptions, i);
  const mm = pick(midMorningOptions, i + 1);
  const ln = pick(lunchOptions, i);
  const es = pick(eveningSnackOptions, i);
  const dn = pick(dinnerOptions, i + 2);
  const bb = pick(beforeBedOptions, i);
  return {
    day: i + 1,
    meals: [
      { key: 'earlyMorning', label: 'Early morning', time: '6:30–7:00 AM', ...em },
      { key: 'breakfast', label: 'Breakfast', time: '8:00–9:00 AM', ...bf },
      { key: 'midMorning', label: 'Mid-morning snack', time: '11:00 AM', ...mm },
      { key: 'lunch', label: 'Lunch', time: '1:00–2:00 PM', ...ln },
      { key: 'eveningSnack', label: 'Evening snack', time: '4:30–5:30 PM', ...es },
      { key: 'dinner', label: 'Dinner', time: '8:00–9:00 PM', ...dn },
      { key: 'beforeBed', label: 'Before bed', time: '10:00 PM', ...bb },
    ],
    total: em.kcal + bf.kcal + mm.kcal + ln.kcal + es.kcal + dn.kcal + bb.kcal,
  };
});

// Build 30-day gain plan — non-vegetarian (8 slots incl. pre & post workout)
export const weightGainPlanNonVeg = Array.from({ length: 30 }, (_, i) => {
  const em = pick(nvEarlyMorningOptions, i);
  const bf = pick(nvBreakfastOptions, i);
  const mm = pick(nvMidMorningOptions, i + 1);
  const ln = pick(nvLunchOptions, i);
  const pre = pick(preWorkoutOptions, i);
  const post = pick(postWorkoutOptions, i);
  const dn = pick(nvDinnerOptions, i + 2);
  const bb = pick(nvBeforeBedOptions, i);
  return {
    day: i + 1,
    meals: [
      { key: 'earlyMorning', label: 'Early morning', time: '6:30–7:00 AM', ...em },
      { key: 'breakfast', label: 'Breakfast', time: '8:00–9:00 AM', ...bf },
      { key: 'midMorning', label: 'Mid-morning snack', time: '11:00 AM', ...mm },
      { key: 'lunch', label: 'Lunch', time: '1:00–2:00 PM', ...ln },
      { key: 'preWorkout', label: 'Pre-workout', time: '4:30 PM', ...pre },
      { key: 'postWorkout', label: 'Post-workout', time: '6:30 PM', ...post },
      { key: 'dinner', label: 'Dinner', time: '8:30 PM', ...dn },
      { key: 'beforeBed', label: 'Before bed', time: '10:30 PM', ...bb },
    ],
    total: em.kcal + bf.kcal + mm.kcal + ln.kcal + pre.kcal + post.kcal + dn.kcal + bb.kcal,
  };
});

export const planTips = {
  loss: [
    'Aim for a 400–500 kcal daily deficit',
    'Drink 2–3 L of water per day',
    'Prioritize protein at every meal',
    'Avoid sugary drinks & processed snacks',
    'Get 7–8 hours of sleep for recovery',
  ],
  lossVeg: [
    'Target 1,200–1,600 kcal/day (adjust to your height/weight/age/activity)',
    'Drink 2.5–3.5 litres of water per day',
    '30–45 min brisk walk daily',
    'Bodyweight strength training 3–4 days/week (squats, push-ups, lunges, planks)',
    'Stretch 10 min after every workout',
    'Foods to eat: whole-wheat roti, brown rice (small portions), oats, daliya, dals, low-fat paneer/tofu, greens, fruits (1–2/day)',
    'Avoid: sugar, sweets, soft drinks, fried & bakery items, packaged snacks, excess white rice & maida',
    'Expected result in 30 days: ~2–4 kg loss (varies by starting weight, activity, sleep & intake)',
  ],
  lossNonVeg: [
    'Gym-focused non-veg plan: high protein, moderate carbs, healthy fats',
    'Drink 3–4 litres of water per day',
    'Workout split — Mon: Chest+Triceps+20 min cardio · Tue: Back+Biceps+20 min cardio · Wed: Legs+Abs · Thu: Shoulders+cardio · Fri: Full-body+HIIT 15–20 min · Sat: 45-min brisk walk or cycling · Sun: rest & stretching',
    'Foods to eat: eggs, chicken breast, fish, plenty of green vegetables, fruits (1–2/day), whole-wheat roti, brown rice (small portions), oats',
    'Avoid: fried foods, soft drinks & sugary beverages, sweets/desserts, alcohol, chips, fast food, bakery items',
    'Weekly progress: ~0.5–1 kg per week (week 1 often includes water weight)',
    'Reaching your target weight may take 5–10 weeks depending on training, sleep & adherence',
  ],
  gain: [
    'Aim for a 300–500 kcal daily surplus',
    'Drink 3–4 litres of water',
    'Sleep 7–9 hours every night',
    'Strength training 4–5 times a week (push-ups, squats, pull-ups, dumbbells, or gym)',
    'Eat every 3–4 hours — never skip a meal',
    'Expected result in 30 days: ~2–4 kg gain (varies by metabolism & activity)',
  ],
  gainNonVeg: [
    'Protein target: 120–160 g per day',
    'Calories: 2,800–3,500 per day (adjust to body size & activity)',
    'Drink 3–4 litres of water',
    'Sleep 7–9 hours per night',
    'Train with progressive overload 4–5 times per week',
    'Foods to eat regularly: eggs, chicken, fish, mutton (1–2×/week), rice, potatoes, oats, milk, peanut butter, bananas, nuts',
    'Expected result in 30 days: ~2–4 kg gain with consistent eating & training',
  ],
};

// Meta info shown on the plan header
export const planMeta = {
  loss: {
    title: '30-Day meal plan',
    subtitle: 'Calorie-controlled for steady, healthy weight loss',
    cuisine: 'Mixed',
  },
  lossVeg: {
    title: '30-Day vegetarian weight-loss plan',
    subtitle: 'Indian-style, 1,200–1,600 kcal/day for healthy fat loss',
    cuisine: 'Indian vegetarian',
  },
  lossNonVeg: {
    title: '30-Day non-veg weight-loss plan',
    subtitle: 'Gym-focused with pre-workout & post-workout meals',
    cuisine: 'Non-vegetarian',
  },
  gain: {
    title: '30-Day Indian vegetarian bulk plan',
    subtitle: 'High-calorie, protein-rich meals for healthy muscle gain',
    cuisine: 'Indian vegetarian',
  },
  gainNonVeg: {
    title: '30-Day non-veg bulk plan',
    subtitle: 'High-protein meals with pre & post-workout nutrition',
    cuisine: 'Non-vegetarian',
  },
};

// ---------------- Personalized nutrition target helper ----------------
// Uses Mifflin–St Jeor BMR + activity multiplier + goal adjustment.
// answers is the user's quiz answers object saved from the funnel.
export const computeTargets = (answers, goalKey = 'loss') => {
  if (!answers) return null;
  // Convert weight to kg
  const wUnit = answers?.measurements?.weightUnit || 'lbs';
  const wRaw = parseFloat(answers?.measurements?.weight);
  if (!wRaw) return null;
  const weightKg = wUnit === 'lbs' ? wRaw * 0.453592 : wRaw;

  // Height to cm
  const hUnit = answers?.measurements?.heightUnit || 'ft';
  let heightCm = null;
  if (hUnit === 'cm') {
    heightCm = parseFloat(answers?.measurements?.heightCm);
  } else {
    const ft = parseFloat(answers?.measurements?.heightFt);
    const inch = parseFloat(answers?.measurements?.heightIn) || 0;
    if (ft) heightCm = ft * 30.48 + inch * 2.54;
  }
  if (!heightCm) return null;

  const age = parseInt(answers?.age ?? answers?.['age-input'], 10) || 30;
  const gender = (answers?.gender || 'male').toLowerCase();

  // Mifflin–St Jeor BMR
  const bmr = gender === 'female'
    ? 10 * weightKg + 6.25 * heightCm - 5 * age - 161
    : 10 * weightKg + 6.25 * heightCm - 5 * age + 5;

  // Activity multiplier — infer from workoutFrequency / fitness-level / workout-location
  const freq = answers?.['workout-frequency'] || answers?.workoutFrequency;
  const location = answers?.['workout-location'] || answers?.workoutLocation;
  let activity = 1.375; // light
  if (freq === 'never') activity = 1.2;
  else if (freq === 'sometimes') activity = 1.375;
  else if (freq === 'often') activity = 1.55;
  else if (freq === 'daily') activity = 1.725;
  if (location === 'gym') activity = Math.max(activity, 1.55);

  const tdee = Math.round(bmr * activity);

  // Goal adjustment
  const isGain = goalKey.startsWith('gain');
  const isLoss = goalKey.startsWith('loss');
  let calorieMin;
  let calorieMax;
  if (isGain) {
    calorieMin = tdee + 300;
    calorieMax = tdee + 500;
  } else if (isLoss) {
    calorieMin = Math.max(1200, tdee - 600);
    calorieMax = Math.max(1400, tdee - 400);
  } else {
    calorieMin = tdee - 100;
    calorieMax = tdee + 100;
  }

  // Protein g/kg
  let proteinPerKg = 1.6;
  if (isGain) proteinPerKg = 2.0;
  if (isLoss && location === 'gym') proteinPerKg = 1.8;
  const proteinMin = Math.round(proteinPerKg * weightKg);
  const proteinMax = Math.round((proteinPerKg + 0.2) * weightKg);

  return {
    weightKg: Math.round(weightKg * 10) / 10,
    heightCm: Math.round(heightCm),
    age,
    gender,
    activityLabel: location === 'gym' ? 'Gym-active' : (freq === 'daily' ? 'Very active' : freq === 'often' ? 'Active' : freq === 'sometimes' ? 'Lightly active' : 'Sedentary'),
    tdee,
    calorieMin: Math.round(calorieMin / 50) * 50,
    calorieMax: Math.round(calorieMax / 50) * 50,
    proteinMin,
    proteinMax,
    waterLitres: isGain ? '3–4' : '2.5–3.5',
  };
};
